import React from 'react';
import { Contact, CTA, Features, Footer, Hero, Nav, Problem, Solution, WhoFor, WhyNow } from '../sections';

export function Home(): React.ReactElement {
  return (
    <div>
      <Nav />
      <main>
        <Hero />
        <Problem />
        <Solution />
        <Features />
        <WhyNow />
        <WhoFor />
        <CTA />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

